import { Link } from 'react-router-dom';
import { Logo } from './Logo';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Logo />
              <span className="text-xl font-bold text-white">Power.ng</span>
            </div>
            <p className="text-sm mb-4">
              Nigeria's premier platform for energy information covering power generation, renewable energy, and oil refining.
            </p>
          </div>

          {/* Tools */}
          <div>
            <h3 className="text-white font-bold mb-4">Interactive Tools</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/tools/bill-calculator" className="hover:text-[#008751] transition-colors">
                  Electricity Bill Calculator
                </Link>
              </li>
              <li>
                <Link to="/tools/tariff-checker" className="hover:text-[#008751] transition-colors">
                  Tariff Band Checker
                </Link>
              </li>
              <li>
                <Link to="/tools/outage-calculator" className="hover:text-[#008751] transition-colors">
                  Outage Cost Calculator
                </Link>
              </li>
              <li>
                <Link to="/tools/solar-sizing" className="hover:text-[#008751] transition-colors">
                  Solar System Sizing
                </Link>
              </li>
              <li>
                <Link to="/solar-quotes" className="hover:text-[#008751] transition-colors">
                  Get Solar Quotes
                </Link>
              </li>
              <li>
                <Link to="/tools/energy-audit" className="hover:text-[#008751] transition-colors">
                  Home Energy Audit
                </Link>
              </li>
              <li>
                <Link to="/tools/refinery-tracker" className="hover:text-[#008751] transition-colors">
                  Refinery Tracker
                </Link>
              </li>
              <li>
                <Link to="/tools/disco-directory" className="hover:text-[#008751] transition-colors">
                  DisCo Directory
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-bold mb-4">Explore</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/grids" className="hover:text-[#008751] transition-colors">
                  Grids
                </Link>
              </li>
              <li>
                <Link to="/renewables" className="hover:text-[#008751] transition-colors">
                  Renewable Energy
                </Link>
              </li>
              <li>
                <Link to="/oil-gas" className="hover:text-[#008751] transition-colors">
                  Oil & Gas
                </Link>
              </li>
              <li>
                <Link to="/articles" className="hover:text-[#008751] transition-colors">
                  Articles & Insights
                </Link>
              </li>
              <li>
                <Link to="/power-manager" className="hover:text-[#008751] transition-colors">
                  Power Manager Game
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-bold mb-4">Platform Info</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-[#008751] transition-colors">
                  About This Platform
                </Link>
              </li>
              <li>
                <Link to="/data-sources" className="hover:text-[#008751] transition-colors">
                  Data Sources
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-[#008751] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="hover:text-[#008751] transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#008751] transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <p className="text-sm text-center">
            © {currentYear} Power.ng. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
